import {useAuth} from "hooks/useAuth";
import React, {ReactNode} from "react";
import {Navigate} from "react-router-dom";


interface LeagueRouteProps {
    children: ReactNode;
}

const LeagueRoute: React.FC<LeagueRouteProps> = ({children}) => {

    const [{league}] = useAuth();

    return <>{league ? children : <Navigate to={"/leagues"}/>}</>;
};

export default LeagueRoute;
